import {Grid} from '@logistics-frontend/blocks'
import React, {memo} from 'react'

import {Header, IconNumber} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'

import {PointAddress} from '../../PointAddress/PointAddress'
import {PointContact} from '../../PointContact/PointContact'
import {PredefinedParcelSelect} from '../PredefinedParcelSelect/PredefinedParcelSelect'
import {DestinationPointProps as Props} from '../types'
import {useDestinationPoint} from './hooks'

export const DestinationPoint = memo<Props>(function DestinationPoint(props) {
  const {orderNumber, RemoveButtonComponent} = props
  const {names} = useDestinationPoint(props)

  return (
    <Grid data-e2e={`destination-point-${orderNumber}`} size="m" container>
      <Grid xs={12} item>
        <Header lead={<IconNumber number={orderNumber} variant="black" />} tail={RemoveButtonComponent}>
          {i18n('cargo.create.destinations.to', 'Куда')}
        </Header>
      </Grid>
      <Grid xs={12} item>
        <PointAddress name={names.address} pointType="b" />
      </Grid>
      <Grid xs={12} item>
        <PointContact
          name={names.contact}
          pointType="b"
          title={i18n('cargo.create.destinations.recipient', 'Получатель')}
          isSmsConfirmationEnabled
        />
      </Grid>
      <Grid xs={12} item>
        <PredefinedParcelSelect name={names.parcels} />
      </Grid>
    </Grid>
  )
})
